import axios from "axios";
import { notification } from "antd";
import get from "lodash/get";
import { LOGOUT } from "../constants/routes";

const configureAxios = () =>
  axios.create({
    baseURL: process.env.REACT_APP_API_REPORT_HOST,
    timeout: 60000*5,
  });

export const axiosReportInstance = configureAxios();

axiosReportInstance.interceptors.request.use((config) => {
  return config;
});

axiosReportInstance.interceptors.response.use(
  (response) => {
    if (response.data.data) return response.data.data;
    else return response.data;
  },
  (err) => {
    
    if (!get(err, "response")) {
      notification.error({
        message: "Something Went wrong",
        description: "Please try again or contact technical team",
      });
    } else {
      notification.error({
        message: get(err, "response.data.message"),
      });
      console.log(get(err, "response.status"))
      if (get(err, "response.status") === 401) {
        console.log("Enter inside axios")
        // eslint-disable-next-line no-undef
        window.location.replace(LOGOUT);
      }
      return Promise.reject(get(err, "response.data"));
    }
  }
);
